import { Fragment, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import { Loading } from "../../utils/helpers/constants";
import RoundLoader from "../loader/RoundLoader";
// import CustomInput from "../CustomInput";
import ErrorInputComponent from "../ErrorInputComponent";
import { attachedNewDocument } from "../../actions/document.action";
import { documentTypes } from "../../utils/mapper/mappers";
import DropDownInput from "../../components/DropDownInput";
import { documentValidator } from "../../utils/helpers/dataHelper";

export default function FileUploadModal({ open, setOpen, cancelButtonRef }) {
  const dispatch = useDispatch();
  const [imageError, setImageError] = useState("");
  const [imageDetails, setImageDetails] = useState({
    imagePreview: "",
    file: "",
  });
  const [modalState, setModalState] = useState(false);

  const {
    document: { attachDocumentLoading, attachDocument, attachDocumentList },
  } = useSelector(({ documentReducer }) => ({
    document: documentReducer,
  }));

  const validationSchema = Yup.object({
    // description: Yup.string().required("Description is required"),
    attachedDocumentType: Yup.string().required("DocumentType is required"),
  });

  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues: {
      // description: "",
      attachedDocumentType: "OTHERS",
    },
    validationSchema,
    onSubmit(values) {
      const payload = {
        attachedDocumentType: values.attachedDocumentType,
        // description: values.description,
      };
      // console.log({ payload });
      const stringRequest = JSON.stringify(payload);
      const blobRequest = new Blob([stringRequest], {
        type: "application/json",
      });
      const formData = new FormData();
      formData.append("imageFile", imageDetails.file);
      formData.append("request", blobRequest);
      const imageFile = imageDetails.file;

      if (imageFile === "") {
        setImageError("image is required");
      } else {
        dispatch(attachedNewDocument(formData));
      }
      setModalState(true);
    },
  });

  const onImageUpload = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImageError("");
      let reader = new FileReader();
      let file = event.target.files[0];
      let isValid = documentValidator(file);
      if (isValid) {
        reader.onloadend = () => {
          setImageDetails({
            ...imageDetails,
            imagePreview: reader.result,
            file: file,
          });
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const loadState = attachDocumentLoading === Loading.FETCHING;

  return (
    <div>
      {loadState ? (
        <RoundLoader />
      ) : (
        <Transition.Root show={open} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-10"
            initialFocus={cancelButtonRef}
            onClose={setOpen}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg text-center overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                      <div className="sm:fle sm:items-star">
                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-center">
                          <Dialog.Title
                            as="h3"
                            className="text-2xl leading-6 font-medium text-gray-900 mb-5"
                          >
                            Upload Document
                          </Dialog.Title>
                          <hr />
                          {/* <CustomInput
                            name="name"
                            handleChange={handleChange}
                            placeholder="Document Description"
                          />
                          <ErrorInputComponent error={errors.description} /> */}

                          <DropDownInput
                            placeholder="Type"
                            name="attachedDocumentType"
                            handleChange={handleChange}
                            list={documentTypes}
                          />
                          <ErrorInputComponent
                            error={errors.attachedDocumentType}
                          />

                          <div className=" border rounded-md py-2 px-4">
                            <div className="flex items-center justify-start">
                              <label className="cursor-pointer">
                                <input
                                  type="file"
                                  onChange={(e) => onImageUpload(e)}
                                  name="image"
                                />
                              </label>
                            </div>
                          </div>
                          <ErrorInputComponent error={imageError} />
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                      <button
                        type="button"
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={() => handleSubmit()}
                      >
                        Submit
                      </button>
                      <button
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={() => setOpen(false)}
                        ref={cancelButtonRef}
                      >
                        Cancel
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      )}
    </div>
  );
}
